export default "__VITE_ASSET__BmuXXgXp__"